import { redirect } from '@tanstack/react-router';

import { getMeQueryOptions } from '@/api/me';
import type { LoaderProps } from '@/lib/router';

export const requireTenantAdmin = async ({ context: { queryClient }, params }: LoaderProps) => {
  const user = await queryClient.ensureQueryData(getMeQueryOptions(params.tenantId));

  if (!user.canAccessSetup) {
    throw redirect({
      to: '/',
    });
  }
};
